import * as React from 'react';

export const DEFAULT_COLOR = 'rgb(216, 254, 255)';

// This isn't a component but ok
export const ColorContext = React.createContext<
  [string, (value: string) => void]
>([DEFAULT_COLOR, () => {}]);
